/**
 * The queries the Sky pages' loading overlay waits for: the charts and the
 * key-metric tiles (speed review, 16 Oct 2026).
 *
 * The comment total and cultural relevance are here because they ARE
 * key-metric tiles — the coverage tile reads the comment total, and a tile
 * showing "0 comments" because its request had not landed is the bug
 * useSkyCommentCount exists to prevent. Everything else (the uncoded summary,
 * the platform-button counts, the output-share pie, the filter facets) loads in
 * its own place without holding the page.
 */
export const SKY_GATING_QUERY_NAMES: ReadonlySet<string> = new Set([
  'chart-batch',
  'entity_metrics',
  'comment-count',
  'cultural_relevance',
])

export function isSkyGatingQuery(queryKey: readonly unknown[]): boolean {
  return typeof queryKey[1] === 'string' && SKY_GATING_QUERY_NAMES.has(queryKey[1])
}
